import Term from "../../term/Term";

export default class Sentence {
  sentence: string;
  transition: string;
  word?: string;

  constructor(sentence: string, trasition: string, word?: string) {
    this.sentence = sentence;
    this.transition = trasition;
    this.word = word;
  }

  static fromJson(json: any): Sentence {
    const example = json.example;
    let sentence: string;
    let translation: string;
    let word: string | undefined;

    if (example !== undefined) {
      sentence = example.sentence ?? example.responseSentence ?? "";
      translation = example.translation ?? example.responseTranslation ?? "";
      word = undefined;
    } else {
      sentence = json.sentence ?? json.responseSentence ?? "";
      translation = json.translation ?? json.responseTranslation ?? "";
      word = json.word;
    }
    return new Sentence(sentence, translation, word);
  }
}

export class TermSentenceWithStringValue {
  term: Term;
  sentence: Sentence;
  stringValue: string;

  constructor(term: Term, sentence: Sentence, stringValue: string) {
    this.term = term;
    this.sentence = sentence;
    this.stringValue = stringValue;
  }
}

export function convertExampleSentenceStringValue(sentence: Sentence): string {
  return sentence.sentence + "\n\n" + sentence.transition;
}
